import { setAutoFreeze } from "immer";
import { providers } from "initializer";
import { UserInfo } from "@firebase/auth-types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

setAutoFreeze(false);

export type AppUser = {
  uid: string | null;
  isAnonymous: boolean | null;
  displayName: string | null;
  photoUrl: string | null;
  email: string | null;
  emailVerified: boolean;
  providerData: Record<keyof typeof providers, UserInfo | null>;
  plan: "free" | "ccfolia-pro";
  isSoundMaster: boolean;
};

const initializeState = (): AppUser => {
  return {
    uid: null,
    isAnonymous: null,
    displayName: null,
    photoUrl: null,
    email: null,
    emailVerified: false,
    providerData: { email: null, google: null, twitter: null },
    plan: "free",
    isSoundMaster: false,
  };
};

const slice = createSlice({
  name: "app/user",
  initialState: initializeState(),
  reducers: {
    patched(state, action: PayloadAction<Partial<AppUser>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updatedProvider(
      state,
      action: PayloadAction<{
        provider: keyof typeof providers;
        userInfo: UserInfo | null;
      }>
    ) {
      state.providerData[action.payload.provider] = action.payload.userInfo;
    },
    updatedEmail(
      state,
      action: PayloadAction<{
        email: string;
        userInfo: UserInfo;
      }>
    ) {
      state.email = action.payload.email;
      state.providerData.email = action.payload.userInfo;
    },
    reseted() {
      return initializeState();
    },
  },
});

export const reducer = slice.reducer;
export const actions = slice.actions;
